/**
 * The web's last actions, for `/issue` (`issue_reports.md` rule 4): a widget
 * or tab opened, a call to the API, a client error. **In memory only**: never
 * on the disk, and sent only by a report the person sees first. A reload
 * empties it.
 *
 * A call keeps its method, path, status and time — never a body, never a
 * query string, which can hold what the person typed.
 */
import type { Schemas } from "../api/client";

export type TrailEntry = Schemas["TrailEntry"];

declare const __COMMIT__: string;

/** The commit this build is of (`vite.config.ts`). */
export const COMMIT = __COMMIT__;

/** Rule 4: the last 50, the oldest dropped first. */
export const TRAIL_MAX = 50;
/** `TrailEntry.text`'s bound on the server. */
const TEXT_MAX = 300;

let entries: TrailEntry[] = [];

const two = (n: number) => String(n).padStart(2, "0");

function clock(now: Date): string {
  return `${two(now.getHours())}:${two(now.getMinutes())}:${two(now.getSeconds())}`;
}

export function note(kind: TrailEntry["kind"], text: string, now = new Date()): void {
  const line = text.split("\n")[0] ?? "";
  entries.push({ at: clock(now), kind, text: line.slice(0, TEXT_MAX) });
  if (entries.length > TRAIL_MAX) entries = entries.slice(-TRAIL_MAX);
}

/** A copy, oldest first: what a report carries. */
export function trail(): TrailEntry[] {
  return entries.slice();
}

export function clearTrail(): void {
  entries = [];
}

/** `GET /api/todos 200 84ms`: the path alone, with no query. */
export function callText(method: string, url: string, status: number | string, ms: number) {
  return `${method} ${new URL(url, "http://k").pathname} ${status} ${Math.round(ms)}ms`;
}
